import React, { useEffect, useState } from 'react';
import { Container, Card, CardBody, Col, Input, Button } from 'reactstrap';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import axios from '../axios';
import SweetAlert from 'react-bootstrap-sweetalert';
import CloseIcon from '@mui/icons-material/Close';
import './addcompanylogo.css';
import { useHistory } from 'react-router-dom';

function AddCompanyLogo() {
  const history = useHistory();
  const [token, setToken] = useState(sessionStorage.getItem('AuthToken'));
  const [added, setAdded] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [previewLogo, setPreviewLogo] = useState(null);
  const [companyLogoPath, setCompanyLogoPath] = useState(null);
  const [previewOpen, setPreviewOpen] = useState(false);

  const GetoneMaterialhdr = async () => {
    const token = sessionStorage.getItem('authtoken');
    const get = await axios.instance
      .get(`GetOneCompanyLogo/${sessionStorage.getItem('Companyid')}`, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json',
        },
      })
      .then(res => {

        if (res.data.length > 0 && res.data[0].Logo_Image !== '') {
          setCompanyLogoPath(
            `${axios.baseURL}CompanyLogoImage/${res.data[0].Logo_Image}`,
          );
          setCompanyLogo(
            `${axios.baseURL}CompanyLogoImage/${res.data[0].Logo_Image}`,
          );
          setPreviewLogo(
            `${axios.baseURL}CompanyLogoImage/${res.data[0].Logo_Image}`,
          );
        }
      });
  };

  useEffect(() => {
    GetoneMaterialhdr();
  }, []);

  const onSelectFile = e => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => {
        setPreviewLogo(reader.result);
        setPreviewOpen(true);
      });
      reader.readAsDataURL(e.target.files[0]);
      setCompanyLogo(e.target.files[0]);
    }
  };

  const insertAdsBanner = async () => {
    if (companyLogo) {
      const formData = new FormData();
      formData.append('Logo_Image', companyLogo);
      formData.append('Company_Id', sessionStorage.getItem('Companyid'));
      try {
        await axios.instance.post('/InserCompanyLogo', formData, {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
        });
        setAdded(true);
        setTimeout(() => {
          setAdded(false);
        }, 2000);
        GetoneMaterialhdr();
      } catch (error) {
        console.error('Error uploading logo:', error);
      } finally {
        setPreviewOpen(false);
      }
    }
  };

  return (
    <React.Fragment>
      <>
        <div>
          <Col lg="12">
            <div className="d-flex">
              <div className="mb-3 w-100 d-flex justify-content-center align-items-center ">
                {(sessionStorage.getItem('CustomerLogin') == 'YES' && companyLogoPath === null) ? <>
                  <button
                    className="button2"
                    onClick={() => {
                      history.push(
                        sessionStorage.getItem('CustomerLogin') === 'YES'
                          ? '/DashboardCustomer'
                          : '/DashboardCompany',
                      );
                    }}
                  >
                    T O M P G
                  </button>
                </> :

                  <div
                    onClick={() => {
                      if (
                        sessionStorage.getItem('WorkScenario') === 'company_login'
                      ) {
                        document.getElementById('ProofDocument').click();
                      }
                    }}
                    className={`d-flex justify-content-center align-items-center mt-3 ${previewLogo === null ? '' : 'card bg_logo'
                      }`}
                  >
                    <Input
                      id="ProofDocument"
                      name="price"
                      type="file"
                      accept="image/*"
                      onChange={onSelectFile}
                      className="form-control"
                      hidden
                    />

                    {previewLogo === null ? (
                      <>
                        <button className="button">ADD LOGO</button>
                      </>
                    ) : (

                      <img
                        src={previewLogo === null ? companyLogoPath : previewLogo}
                        alt="Company Logo"
                        style={{
                          maxWidth: '180px',
                          maxHeight: '80px',
                          objectFit: 'contain',
                        }}
                      />
                    )}
                  </div>
                }
              </div>
            </div>
          </Col>
        </div>

        <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)}>
          <DialogTitle>Preview Logo</DialogTitle>
          <DialogContent dividers>
            <img
              src={previewLogo}
              alt="Company Logo"
              style={{ width: '100%' }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setPreviewOpen(false)}>Cancel</Button>
            <Button onClick={insertAdsBanner} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        {added && (
          <SweetAlert
            title="Company Logo Updated Successfully"
            timeout={3000}
            style={{
              position: 'absolute',
              justifyContent: 'center',
              alignItems: 'center',
              color: 'green',
            }}
            showCloseButton={false}
            showConfirm={false}
            success
            onConfirm={() => {
              setAdded(false);
            }}
          ></SweetAlert>
        )}
      </>
    </React.Fragment>
  );
}

export default AddCompanyLogo;
